import "./App.css";
import React from "react";
import SongOverview from "./components/SongOverview";

function App() {
  return (
    <div>
      <SongOverview />
    </div>
  );
}

export default App;
